import { Box, Button, LinearProgress, TextField } from "@mui/material";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { oktaLogIn } from "../services/users";
import { getWorlds } from "../services/worlds";
import { setUser, setWorlds } from "../redux/features/user";
import { getData, storeData } from "../utils/storeData";

export default function Okta() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let role = null;
  let token = "";

  const handleLogIn = () => {
    if (userName === "" || password === "") {
      setError("Debes ingresar usuario y contraseña.");
      return;
    }

    setIsLoading(true);
    oktaLogIn(userName, password).then((res) => {
      setIsLoading(false);
      if (res.data.User) {
        role = res.data.User.role;
      }
      if (res.data.token) {
        token = res.data.token;
      }
      if (res.data.StatusCode === 200) {
        getWorlds(userName, token).then((res) => {
          if (res.status === 200) {
            dispatch(setUser({ userName, role, token }));
            storeData("ur", role);
            storeData("un", userName);
            storeData("tt", token);
            dispatch(setWorlds(res.data));
            navigate("/");
          }
        });
      } else {
        setError(
          res.data.mensaje === "Bad credentials"
            ? "El usuario o la contraseña son incorrectos."
            : "Error desconocido. Vuelve a intentarlo."
        );
      }
    });
  };

  const handleUser = (e) => {
    setUserName(e.target.value);
    setError(false);
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
    setError(false);
  };

  return (
    <div id="admin-login">
      <div>
        <div className="txt">Iniciar sesión</div>
        <TextField
          id="outlined-basic"
          label="Usuario"
          variant="outlined"
          value={userName}
          onChange={handleUser}
        />
        <TextField
          id="outlined-basic"
          label="Contraseña"
          variant="outlined"
          type="password"
          value={password}
          onChange={handlePassword}
        />
        <div className="error" style={{ opacity: error ? 1 : 0 }}>
          {error || ""}
        </div>
        <Button variant="contained" onClick={handleLogIn}>
          Iniciar sesión
        </Button>
        {isLoading && (
          <div className="loading">
            <Box sx={{ width: "100%" }}>
              <LinearProgress />
            </Box>
          </div>
        )}
      </div>
    </div>
  );
}
